import * as React from "react";
import { styled } from "@mui/system";
import MUICardContent from "@mui/material/CardContent";
import {
  CardContentProps as CardContentPropsMUI,
  CardContentTypeMap
} from "@mui/material/CardContent";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface CardContentProps extends CardContentPropsMUI {}

export const CardContent: OverridableComponent<CardContentTypeMap> =
  MUICardContent;
